import { render, staticRenderFns } from "./his.vue?vue&type=template&id=582ca22c&scoped=true&"
import script from "./his.vue?vue&type=script&lang=ts&"
export * from "./his.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ca22c",
  null
  
)

export default component.exports